module.exports = __webpack_public_path__ + "img/imagen2.1cfe769c.png";